import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=428f2d45&scoped=true&"
import script from "./Pay.vue?vue&type=script&lang=js&"
export * from "./Pay.vue?vue&type=script&lang=js&"
import style0 from "./Pay.vue?vue&type=style&index=0&id=428f2d45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../东方蚂蚁/e-shop/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f2d45",
  null
  
)

export default component.exports